
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, debounce, FormControl, Grid, LinearProgress, MenuItem, Select, SelectChangeEvent, SelectProps, TextField, Autocomplete, } from "@mui/material";

import Box from "@mui/material/Box";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { config } from "../../Constants";
import useAuth from "../../context/AuthProvider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autorenew, Close, Search } from "@mui/icons-material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { FMFilters, getCompletedFilings__Resp, NewCompletedFilingsModel, getPolicyFilingAndReport } from "../../models/NewCompletedFilingsModel";
import { RemovedFilingQueue } from "./RemovedFilingQueue";
import Swal from "sweetalert2";
import moment from "moment";
import { writeXlsxFile, formatUtcToLocal, mstDateStringToUtcIsoString } from "../../helper/utils";
import { columnListDetailed, columnListShort, excelItemsAll, excelItemsDetailed, excelItemsShort } from "../../components/Elements/ColumnList";
import { GridFilterItem, GridFilterModel, GridLinkOperator, GridSortModel } from "@mui/x-data-grid-pro";
import { isValid } from "../../components/Elements/PolicyStatuses";
import { ReconciliationTransactionReportModel_Resp, ReconciliationTransactionReportModel } from "../../models/TaxTransactionReportModel";
import { MenuDropdown } from "../../components/Elements/MenuDropdown";
import formatPrice from "../../helper/currencyFormatter";
import FilerNotes from "../../components/Elements/filerNotes";
import { Form, Formik } from "formik";
import { FMTextField } from "../../components/Elements/input";
import { apiClient } from "../../helper/api";

const initValue: getCompletedFilings__Resp = {
  getCompletedFilings_Respdata: [],
  totalCount: 0
}

interface newProp {
  handleClose: () => void;
  open: boolean;
}
export enum FMTabs {
  OutStandingFiling = 8,
  ReadyToFiling = 6,
  CompletedFiling = 5
}

export interface ModelForFilters {
  agency?: string;
  invoiceNumber ? : string
  insuredName?: string;
  policyNumber?: string;
  client?: string;
  taxAmt?: string;
  homeState?: string;
  transactionTypeName?: string;
  invoiceDate?: string;
  effectiveDate?: string;
  policyExpDate?: string;
  dateFiled?: string;
  grossPremium?: string;
  status?: string;
  customerPolicyId: number;
  pageSize?: number;
  pageNumber?: number; 
  field?: string; 
  sort?: string;
  dueDate? : string;
  stateId?: number;
  customerId?: number;
}
interface StatusUpdateProp {
  // selectedRows: ReconciliationTransactionReportModel[] | null;
  paymentPeriod?: string;
  isPaid: boolean;
}

export function RemovedQueue() {

  const value = window.location.pathname.includes('FilingQueue');
  const { user } = useAuth();
  const token = user?.token;
  const [loading, setloading] = React.useState(false);
  const [newComponentDatawithCount, setNewComponentData] = useState<getCompletedFilings__Resp>(initValue)

  const [componentData, setcomponentData] = useState([]);
  const [stateId, setstateId] = useState(0);

  const [PolNumber, setpolNumber] = useState("");
  const [insuredName, setinsuredName] = useState("");

  const [effectiveDateEnd, seteffectiveDateEnd] = useState("");
  const [effectiveDateStart, seteffectiveDateStart] = useState("");
  const params = useParams();

  const PloicyNum = React.useRef("");
  const encodedPolicyNumber = encodeURIComponent(PloicyNum.current);
  const insName = React.useRef("");
  const effectiveDateEd = React.useRef("");
  const effectiveDateSt = React.useRef("");
  const stateData = React.useRef(0);
  const customerData = React.useRef(0);
  const [customerId, setCustomerId] = useState(0);
  const [getCustomerPolicyIds, setCustomerPolicyIds] = React.useState<number[]>([]);
  const [_currentPage, setCurrentPage] = React.useState(1);
  const [_pageSize, setPageSize] = React.useState(50);
  const [totalCount, setTotalCount] = React.useState(0);
  const sortModelRef = useRef<GridSortModel>([]);
  const [openPaidDialog, setOpenPaidDialog] = useState(false);
  const [filterModel, setFilterModel] = useState<{ items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }>({ items: [], logicOperator: 'and' });
  const [sortModel, setSortModel] = useState([{ field: "", sort: "" }]);

  var firstDataCount = 0
  const initValue1: ReconciliationTransactionReportModel_Resp = {
    getData_Resp: [],
    totalCount: 0
  }
  const [ReportModule, setReportModule] = useState<ReconciliationTransactionReportModel_Resp>(initValue1)
  const [selectedRows, setSelectedRows] = useState<NewCompletedFilingsModel[] | null>([]);
  const [selectedRowsRecon, setSelectedRowsRecon] = useState<ReconciliationTransactionReportModel[] | null>([]);
  const [currentPolicySubStatus, setCurrentPolicySubStatus] = useState<string>('');
  const [openNotesDialog, setOpenNotesDialog] = useState<string>('');
  
  const [editableSelectedRows, seteditableSelectedRows] = useState<NewCompletedFilingsModel[]>();
  const [openPolicyDueDateNullDialog, setOpenPolicyDueDateNullDialog] = useState(false);
  const [CustPolicyNullDueDateData, SetCustPolicyNullDueDateData] = React.useState<any>();
  const filteredSelectedRows: NewCompletedFilingsModel[] | null = selectedRowsRecon
  ?.filter((item): item is NewCompletedFilingsModel => item.customerPolicyId !== undefined) ?? null;

  interface dataParams {
    customerPolicyId: number
  }
  const initCustValue: dataParams = {
    customerPolicyId: 0
  }

  const getCustomerPolicyDetails = async (customerPolicyId: number): Promise<string> => {
    try {
      setloading(true);
      const initCustValue = {
        customerPolicyId: customerPolicyId
      };
      var action = 'getPolicySubStatusByCustomerPolicyId';
      const response = await fetch(
        config + `/PolicyDashBoard/${action}`,
        {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }),
          body: JSON.stringify(initCustValue)
        }
      );

      if (!response.ok) {
        throw new Error("Something went wrong");
      }
      const res = await response.json();
      if (res.data !== null) {
        setloading(false);
        return res.data.policySubStatus;
      } else {
        setloading(false);
        throw new Error("Response data is null");
      }
    } catch (error) {
      setloading(false);
      throw error;
    }
  };

  const [queryOptions, setQueryOptions] = React.useState<FMFilters>();

  interface dataExportParams {
    customerPolicyIds: number[],
    option: string
  }
  const initValueExport: dataExportParams = {
    customerPolicyIds: [],
    option: ""
  }
  const getCustomerPolicyListbyTaxType = (action: string, customerPolicyIds: number[], option: string) => {
    setloading(true);
    if (customerPolicyIds.length === 0) {
      customerPolicyIds = getCustomerPolicyIds
    }

    if(customerPolicyIds.length == 0) {
      customerPolicyIds = newComponentDatawithCount.getCompletedFilings_Respdata?.map((m: any) => m.customerPolicyId) || [];
    }

    initValueExport.customerPolicyIds = customerPolicyIds;
    initValueExport.option = option;
    console.time('===getCustomerPolicyListbyTaxType===')
    fetch(
      config +
      `/PolicyDashBoard/${action}`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(initValueExport)
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((res) => {
        console.timeEnd('===getCustomerPolicyListbyTaxType===')
        if (res.data !== null) {
          let totalData: NewCompletedFilingsModel[] = [];
          if(res.data.outstandingFilingsData !== null){
            totalData = [...totalData, ...res.data.outstandingFilingsData]
          }
          if(res.data.completedFilingsData !== null){
            totalData = [...totalData, ...res.data.completedFilingsData]
          }
          if(res.data.closedFilingsData !== null){
            totalData = [...totalData, ...res.data.closedFilingsData]
          }
          if (totalData.length !== 0) handleExport(totalData, option, "ExportFilingsData").then(() => {
            //window.location.reload();
          });
          if (res.data.selectedFilingsData !== null) handleExport(res.data.selectedFilingsData, option, "CustomerPolicyData").then(() => {
            // window.location.reload();
          });
        }
        setloading(false);
      }).then(() => {
        setSelectedRows([]);
      })
      .catch((error) => {
        setloading(false);
      });
  };

  function convertDateFormat(dateStr: string): string | undefined {
    if (!dateStr || isNaN(Date.parse(dateStr))) {
      return undefined;
    }

    return formatUtcToLocal(dateStr, "MM/DD/YYYY");
  }
  

  const handleExport = async (items: NewCompletedFilingsModel[], option: string, fileName: string) => {
    if (items.length === 0) {
      return
    }
    var filterExcelItem = option === "Short" ? excelItemsShort : option === "Detailed" ? excelItemsDetailed : option === "All" ? excelItemsAll : excelItemsShort;
    var filterColumnList = option === "Short" ? columnListShort : option === "Detailed" ? columnListDetailed : option === "All" ? columnListShort : columnListShort;
    fileName = option + '_' + fileName;
    const updates1: { [x: string]: any[] } = {}
    filterExcelItem.forEach(ex => {
      const headerRow = ex.columnOrder.map(idx => filterColumnList[idx].xlsHeader[0])
      updates1[fileName] = [headerRow]
    })

    items.forEach(item => {
      if (item.homeState === "NY" &&
        (item.transactionTypeName === "New Business" || item.transactionTypeName === "Renewal Business") &&
        item.filerNotes === "Filed on binder, need dec page") {
        item.filerNotes = "Need Dec Page";
      }
      const xlsHeaders: string[] = []
      Object.keys(item).map((field) => {
        if (!item[field as keyof NewCompletedFilingsModel]) return
        const column = filterColumnList.find(col => col.field === field)
        if (!column?.xlsHeader) return
        xlsHeaders.push(column.xlsHeader[0])
      })

      // date fromating
      item.effectiveDate = convertDateFormat(item.effectiveDate ?? '');
      item.dateFiled = convertDateFormat(item.dateFiled ?? '');
      item.dateInvoiceAdded = convertDateFormat(item.dateInvoiceAdded ?? '');
      item.invoiceDate = convertDateFormat(item.invoiceDate ?? '');
      item.dueDate = convertDateFormat(item.dueDate ?? '');
      item.policyExpDate = convertDateFormat(item.policyExpDate ?? '');
      item.paymentNoticeDate = convertDateFormat(item.paymentNoticeDate ?? '');
      item.diligentSearchToGMAC = convertDateFormat(item.diligentSearchToGMAC ?? '');
      item.firstRequest = convertDateFormat(item.firstRequest ?? '');
      item.secondRequest = convertDateFormat(item.secondRequest ?? '');
      item.thirdRequest = convertDateFormat(item.thirdRequest ?? '');

      const excelItem = filterExcelItem[0]
      const update1 = excelItem.columnOrder.map(idx => {
        const column = filterColumnList[idx]
        const field = column.field as keyof NewCompletedFilingsModel
        let value = item[field];
        if (
          field === "grossPremium" ||
          field === "taxAmt" ||
          field === "nonAdmittedPremium" ||
          field === "taxableFees" ||
          field === "nonTaxableFees" ||
          field === "taxBalance"
      ) {
        let cleanedValue = value?.replace(/[,\$]/g, "").trim();
        
        // If the value is in parentheses, it's negative, so handle that
        if (cleanedValue?.startsWith("(") && cleanedValue?.endsWith(")")) {
            cleanedValue = "-" + cleanedValue?.slice(1, -1); // Remove parentheses and add a negative sign
        }

        // Convert to number and pass to formatPrice
        const numericValue = parseFloat(cleanedValue);

        // If numericValue is a valid number, format it; otherwise, return the original string
        value = isNaN(numericValue) ? value : numericValue?.toString();
      }
        // const value = item[field];
        // const formattedValue = typeof value === 'string' ? value.replace(/[^0-9.]/g, '').trim() : value;

        // const numericValue = formattedValue ? parseFloat(formattedValue) : 0;
        if (value === undefined || value === null) return
        switch (column.inputType) {
          case 'string':
            return value.toString()
          case 'custom':
            return value ? moment.utc(value as string).startOf('day').toDate() : undefined;
          case 'number':
            return +value
          case 'bool':
            return !!value
          default:
            return value
        }
      })

      updates1[fileName].push(update1)
      //updates1[excelItem.name].push(update1)
    })

    console.log({ updates1 })
    console.timeEnd('===handleExport===')

    filterExcelItem.forEach(excelItem => {
      if (!updates1[fileName] || updates1[fileName].length <= 1) return
      // const timeStamp = moment().format('MM.DD.YYYY')
      writeXlsxFile(updates1[fileName], `${fileName}.xlsx`)
    })
  }

  const initialUserdata = { partnersId: 0, customerName: "" };
  const [Customer, setCustomer] = useState([initialUserdata]);
  const fetchCustomer = () => {
    fetch(config + "/Partners/getPartners", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        // Do something with the response

        setCustomer(responseJson.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const FMSelectCustomCustomer: React.FC<SelectProps> = ({
    variant,
    ...props
  }) => {
    const { user } = useAuth();
    const token = user?.token;

    return (
      <div>
        <FormControl fullWidth>
          {/* <InputLabel id="test-select-label"></InputLabel> */}
          <Autocomplete
            sx={{
              // Parent/Container Style
              marginTop: '-4px !important',
              
              // Target nested Input
              '& .MuiAutocomplete-input': {
                padding: '0px 4px 0px 5px !important',
              },
            }}
            options={Customer}
            getOptionLabel={(option) => option.customerName}
            onChange={(event, value) => setCustomerId(value?.partnersId ?? 0)}
            value={Customer.find(item => item.partnersId === customerId)}
            renderInput={(params) => {
              return <TextField
              sx={{
                '.MuiFormLabel-root.Mui-focused': {
                  color: (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0) ? '#000' : '#cccccc !important'
                },
                '& .MuiInputBase-root': { marginTop: '5px !important' },
                '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
              }}
              {...params}
              label="Client"
              InputLabelProps={{ ...params.InputLabelProps, shrink: (customerId > 0 || (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0)) ? true : false }}
            />
            }}
          />
          {/* <Select
            onChange={(e: SelectChangeEvent) => setCustomerId(Number(e.target.value))}
            value={customerId.toString()}
            id="test-select-label"
            autoWidth
            size="small"
            label={null}
            className="border-round custom-menu-item"
            IconComponent={ExpandMoreIcon}
            displayEmpty
          >
            <MenuItem key={0} value={0} className="custom-menu-item">
              Client
            </MenuItem>
            {Customer?.map((item, key) => (
              <MenuItem
                key={key}
                className="custom-menu-item"
                value={item.partnersId}
              >
                {item.customerName}
              </MenuItem>
            ))}
          </Select> */}
        </FormControl>
      </div>
    );
  };

  const initialStatedata = { stateId: 0, stateName: "" };
  const [States, setStates] = useState([initialStatedata]);

  const fetchStateData = () => {
    fetch(config + "/States/getStates", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        // Do something with the response

        setStates(responseJson.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCloseNotesDialog = () => {
    setOpenNotesDialog('');
  };

  const handleSubmitNotes = (data: { status: string, noteType: string, noteDetail: string, noteUser: string, firstRequestDate: string, secondRequestDate: string, thirdRequestDate: string, suspendedDate: string, noteDate?: string, policySubStatus?: string, dateDeclarationFiled?: string }) => {
    const { firstRequestDate, secondRequestDate, thirdRequestDate, suspendedDate, noteType, noteDetail, noteUser, noteDate, status, policySubStatus, dateDeclarationFiled } = data;
    setOpenNotesDialog('');
    updateAllStatus(status, selectedRowsRecon, noteDetail, noteUser, firstRequestDate, secondRequestDate, thirdRequestDate, suspendedDate, noteDate, policySubStatus, dateDeclarationFiled);
  };

  const getTaxTypeData = async (action: string, customerPolicyIds: number[]) => {
    try {
        //  setloading(true);

        const initValueExport = {
            customerPolicyIds: customerPolicyIds,
            option: ''
        };

        const response = await fetch(
            config + `/PolicyDashBoard/${action}`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
                body: JSON.stringify(initValueExport)
            }
        );

        if (!response.ok) {
            throw new Error("Something went wrong");
        }

        const res = await response.json();

        if (res.data !== null) {
            //  setloading(false);
            return res.data;
        } else {
            // setloading(false);
            throw new Error("Response data is null");
        }
    } catch (error) {
        // setloading(false);
        throw error;
    }
  };

  const isDueDateWithinRange = (dueDateStr: string): boolean => {
    const currentDate = new Date();
    const dueDate = parseDueDate(dueDateStr);
    const dateDifference = dueDate.getTime() - currentDate.getTime();
    const dayDifference = dateDifference / (1000 * 3600 * 24);
    return dayDifference >= 0 && dayDifference <= 9;
  };
  const parseDueDate = (dueDateStr: string): Date => {
    const currentDate = new Date();
    const [month, day] = dueDateStr.split('-').map(Number);
    const year = currentDate.getFullYear();
    return new Date(year, month - 1, day);
  };

  var count = 0;
  function updateAllStatus(status: string, selectedRow: any, notes: string = '', filerName: string = '', firstRequestDate: string = '', secondRequestDate: string = '', thirdRequestDate: string = '', suspendedDate: string = '', noteDate?: string, policySubStatus: string = '', dateDeclarationFiled: string = '') {
    setloading(true);
    if (noteDate === null || noteDate === '' || noteDate === undefined) {
        noteDate = formatUtcToLocal(new Date().toISOString(), "MM/DD/YYYY");
    }
    if (status === "Filed") {
        var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId) ?? [];
        if (count === 0) {

            (async () => {
                try {
                    const customerPolicyIds: number[] = selectedRows
                                            ?.map(m => m.customerPolicyId)
                                            .filter((id): id is number => id !== undefined) ?? [];

                    // Now you can safely pass it to `getTaxTypeData`
                    const response = await getTaxTypeData('getIsPolicyFilingAndReportByCustPolIds', customerPolicyIds);

                    if (response != null && response.length > 0) {
                        const dueDateNotValid: NewCompletedFilingsModel[] = []; // where due date is not prior 10 days of due date
                        response.forEach((e: getPolicyFilingAndReport) => {
                            if (e.report == true) {
                                var newData = selectedRows?.find(m => m.customerPolicyId == e.customerPolicyId);
                                if (!isDueDateWithinRange(newData?.dueDate) && newData !== undefined && newData.customerPolicyId !== undefined) {
                                    dueDateNotValid.push(newData as NewCompletedFilingsModel);
                                }
                            }
                        });

                        const DueDateNotValid = new Set(dueDateNotValid.map(item => item.customerPolicyId));
                        const filteredSelectedIds: NewCompletedFilingsModel[] | undefined = selectedRows
                            ?.filter((item): item is NewCompletedFilingsModel => 
                                item.customerPolicyId !== undefined && !DueDateNotValid.has(item.customerPolicyId)
                            );
                        console.log("filteredSelectedIds :", filteredSelectedIds);
                        count++;
                        if (dueDateNotValid.length > 0) {
                            seteditableSelectedRows(filteredSelectedIds)
                            SetCustPolicyNullDueDateData(dueDateNotValid);
                            setOpenPolicyDueDateNullDialog(true);
                        }
                        else {
                            SetCustPolicyNullDueDateData(null);
                            setOpenPolicyDueDateNullDialog(false);
                            seteditableSelectedRows(undefined);
                            updateAllStatus("Filed", filteredSelectedIds, notes, filerName, firstRequestDate, secondRequestDate, thirdRequestDate, suspendedDate, noteDate, policySubStatus, dateDeclarationFiled);
                        }
                    }
                    setloading(false);
                    return;
                } catch (error) {
                    console.error("Error fetching tax type data:", error);
                    return;
                }
            })();
            return;
        }
    }
    setOpenPolicyDueDateNullDialog(false);

    fetch(config + `/PolicyDashBoard/updateCustomerPolicyStatus?status=${status}&&notes=${notes}&&filerName=${user?.userFirstName + ' ' + user?.userlastName}&&filerDate=${encodeURIComponent(mstDateStringToUtcIsoString(noteDate))}&&firstRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(firstRequestDate))}&&secondRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(secondRequestDate))}&&thirdRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(thirdRequestDate))}&&suspendedDate=${encodeURIComponent(mstDateStringToUtcIsoString(suspendedDate))}&&policySubStatus=${policySubStatus}&&dateDeclarationFiled=${dateDeclarationFiled}`, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(selectedRow)
    })
        .then((response) => {
            setloading(false);
            if (response.ok) {
                return response.json();
            }
            throw new Error("Something went wrong");
        })
        .then((res) => {
            setloading(false);
            if (res !== null && res !== undefined) {
                 Swal.fire({
                    title: res.data,
                    text: res.message,
                    iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    confirmButtonColor: '#02A4E3',
                    confirmButtonText: 'OK',
                    customClass: {
                        confirmButton: 'btn-radius',
                        cancelButton: 'btn-radius',
                        popup: 'card-radius'
                    }
                })
                    .then((result) => {

                        setSelectedRows([]);
                        window.location.reload();
                    })
            }
        })
        .catch((error) => {
            console.log(error);
            setloading(false);
        });
  }

  const FMSelectStateCustom: React.FC<SelectProps> = ({
    variant,
    ...props
  }) => {
    const { user } = useAuth();
    const token = user?.token;
    return (
      <FormControl fullWidth>
        <Autocomplete
          sx={{
            // Parent/Container Style
            marginTop: '-4px !important',
            
            // Target nested Input
            '& .MuiAutocomplete-input': {
              padding: '0px 4px 0px 5px !important',
            },
          }}
          options={States}
          getOptionLabel={(option) => option.stateName}
          onChange={(event, value) => setstateId(value?.stateId ?? 0)}
          value={States.find(item => item.stateId === stateId)}
          renderInput={(params) => {
            return <TextField
              sx={{
                '.MuiFormLabel-root.Mui-focused': {
                  color: (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0) ? '#000' : '#cccccc !important'
                },
                '& .MuiInputBase-root': { marginTop: '5px !important' },
                '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
              }}
              {...params}
              label="Home State"
              InputLabelProps={{ ...params.InputLabelProps, shrink: (stateId > 0 || (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0)) ? true : false }}
            />
          }}
        />
        {/* <Select
          onChange={(e: SelectChangeEvent) => setstateId(Number(e.target.value))}
          value={stateId.toString()}
          size="small"
          id="test-select-label"
          // autoWidth
          label={null}
          className="border-round custom-menu-item"
          IconComponent={ExpandMoreIcon}
          displayEmpty
        >
          <MenuItem value={"0"} className="custom-menu-item">Home State</MenuItem>
          {States?.map((state, key) => (
            <MenuItem
              key={key}
              value={state.stateId}
              className="custom-menu-item"
            >
              {state.stateName}
            </MenuItem>
          ))}
        </Select> */}
      </FormControl>
    );
  };
  const [tax, setTax] = useState("");
  const taxData = React.useRef("");
  const [TaxandFees, setTaxandFees] = useState<string[]>([""]);
  const [statuses, setstatus] = useState("");
  const statusData = React.useRef("");
  const statusList = [
    'Not Started',
    'Waiting on Client',
    'Ready to File',
    'Filed',
    'Pending Autofile',
    'Filed - Binder'
  ];
  if (user?.userRoles.split(",").includes("Super Admin")) {
    statusList.push('Removed');
  }


const fetchTaxFeeName = () => {
  fetch(config + `/PolicyFilingType/GetAllTaxandFeeName`, {
      method: "GET",
      headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
      }),
  })
      .then((response) => {
          if (response.ok) {
              return response.json();
          }
          throw new Error("Something went wrong");
      })
      .then((responseJson) => {
          if (responseJson.data != null) {
              setTaxandFees(responseJson.data);
          }

          console.log("TaxandFees", responseJson.data);
      })
      .catch((error) => {
          console.log(error);
      });
};

  useEffect(() => {
    setcomponentData([]);
    fetchStateData();
    fetchCustomer();
    fetchTaxFeeName();
  }, []);

  useEffect(() => {
    fetchDataSorting(_pageSize, _currentPage);
  }, [_pageSize, _currentPage, filterModel, sortModel]);

  const FMSelectTaxAndFeesCustom: React.FC<SelectProps> = ({
    variant,
    ...props
  }) => {
      const handleTaxChange = (event: SelectChangeEvent<string>) => {
          const selectedTax = event.target.value;
          setloading(true); // Correctly use setLoading
          setTax(selectedTax);
          taxData.current = selectedTax;
          console.log('taxcurrentdata', taxData.current);
          setloading(false);
      };

      return (
          <div>
              <FormControl fullWidth>
                  <Select
                      onChange={handleTaxChange}
                      value={tax}
                      id="test-select-label"
                      autoWidth
                      size="small"
                      label={null}
                      className="border-round custom-menu-item"
                      IconComponent={ExpandMoreIcon}
                      displayEmpty
                  >
                      <MenuItem key={""} value={""} className="custom-menu-item">
                          Tax Type
                      </MenuItem>
                      {TaxandFees?.map((taxdata, key) => (
                          <MenuItem
                              key={key}
                              className="custom-menu-item"
                              value={taxdata}
                          >
                              {taxdata}
                          </MenuItem>
                      ))}
                  </Select>
              </FormControl>
          </div>
      );
  };

  function RunSearch() {
    setloading(true);
    PloicyNum.current = PolNumber;
    insName.current = insuredName;
    stateData.current = stateId;
    customerData.current = customerId;
    fetchDataSorting(_pageSize, _currentPage);
    setloading(false);
  }

  function ClearSearch() {
    setloading(true);
    seteffectiveDateStart("");
    seteffectiveDateEnd("");
    setpolNumber("");
    setinsuredName("");
    setCustomerId(0);
    setstateId(0);
    setstatus("");
    setTax("");
    setloading(false);

    PloicyNum.current = "";
    insName.current = "";
    stateData.current = 0;
    customerData.current = 0;
    effectiveDateEd.current = "";
    effectiveDateSt.current = "";
    fetchDataSorting(_pageSize, _currentPage);
    setloading(false);
  }
  const fetchDataSorting = async (pageSize: number, pageNumber: number) => {
    setloading(true);
    const bodyParams = {
      userId: user?.userId,
      partnersId: customerData.current,
      policyNumber: PloicyNum.current,
      stateId: stateData.current,
      insuredName: insName.current,
      pageNumber: pageNumber,
      pageSize: pageSize,
      filterModel: JSON.stringify(filterModel),
      field: sortModel?.[0]?.['field'] || '',
      sort: sortModel?.[0]?.['sort'] || '',
      tabName: 'Removed',
    };

    try {
      const res = await apiClient(`/PolicyDashBoard/getFilingQueueData`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(bodyParams)
      })

      if (res.data.getCompletedFilings_Respdata) {
        setNewComponentData(res.data);
      } else {
        setNewComponentData(initValue);
      }
    } catch (error) {
      setloading(false);
      setNewComponentData(initValue);
      throw error;
    }
    finally {
      setloading(false);
    }
  };

  function checkSelectedRowsForNY(): boolean {
    if (selectedRows?.find(x => x.homeState === 'NY')) {
        if (selectedRows.find(x => x.homeState !== 'NY')) {
            Swal.fire({
                title: 'Warning!',
                text: "Please select filings either specifically for New York or those that exclude New York, as there is a special rule for changing the status in New York.",
                iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                // showCancelButton: true,
                confirmButtonColor: '#02A4E3',
                // cancelButtonColor: '#d33',
                // confirmButtonText: 'Proceed',
                customClass: {
                    confirmButton: 'btn-radius',
                    // cancelButton: 'btn-radius',
                    popup: 'card-radius'
                }
            })
                .then((result) => {

                });
            return false;
        }


    }
    return true;
  }

  const handleOpenNotesDialog = (status: string) => {
    setOpenNotesDialog(status);
  };

  function updateStatus(status: string, selectedRow: any) {
    setloading(true);

    fetch(config + `/PolicyDashBoard/updateCustomerPolicyStatus?status=${status}&&filerName=${user?.userFirstName + ' ' + user?.userlastName}`, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        }),
        body: JSON.stringify(selectedRow)
    }).then((response) => {
        setloading(false);
        if (response.ok) {
            return response.json();
        }
        throw new Error("Something went wrong");
    }).then((res) => {
        setloading(false);
        if (res !== null && res !== undefined) {
            Swal.fire({
                title: res.data,
                text: res.message,
                iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                confirmButtonColor: '#02A4E3',
                confirmButtonText: 'OK',
                customClass: {
                    confirmButton: 'btn-radius',
                    cancelButton: 'btn-radius',
                    popup: 'card-radius'
                }
            }).then((result) => {
                window.location.reload();
            })
        }
    }).catch((error) => {
        console.log(error);
        setloading(false);
    });
  }

  function handleStatus(status: string) {
    if (!checkSelectedRowsForNY()) {
        return;
    }
    setCurrentPolicySubStatus('');
    const isNewYorkFiling = selectedRows && selectedRows?.length === 1 && selectedRows[0].homeState === 'NY' && (selectedRows[0].transactionTypeName === 'New Business' || selectedRows[0].transactionTypeName === 'Renewal Business')
    console.log("status------------", status);
    Swal.fire({
      title: 'Confirmation!',
      text: "Do you want to update customer policy's status as " + status + "?",
      iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Proceed',
      customClass: {
        confirmButton: 'btn-radius',
        cancelButton: 'btn-radius',
        popup: 'card-radius'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        setloading(true);
        if (status !== undefined && status !== '' && status !== null) {
          setCurrentPolicySubStatus('');
          updateStatus(status, selectedRows);

        }
      }
    });

    setloading(false);
  }

  async function fetchExportData(action: string, customers: string | string[], pageSize: number, pageNumber: number, selectedRows: any) {

    setloading(true);
    var MultiplePolicyIds: string = selectedRows?.map((x: { customerPolicyId: string }) => x.customerPolicyId).join(",") ?? "";
    const response = await fetch(
        config +
        `/ReconQueue/${action}?userId=${user?.userId}&&policyNumber=${PloicyNum.current}
        &stateId=${stateData.current}&effectiveDateStart=${effectiveDateSt.current}&effectiveDateEnd=${effectiveDateEd.current}
        &taxName=${encodeURIComponent(taxData.current)}&status=${encodeURIComponent(statusData.current)}
        &insuredName=${insName.current}&customerId=${customerData.current}&&customerIds=${MultiplePolicyIds}&&pageSize=${pageSize}&&pageNumber=${pageNumber}`,
        {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        }
    )
        .then((response) => {
            setloading(false)
            if (response.ok) {
                return response.json();
            }
            throw new Error('Something went wrong');
        })
        .then((res) => {
            setloading(false)
            if (res.data.totalCount > 0) {

                if (pageSize <= 100) {
                    setReportModule(res.data)
                }


                return res.data.getData_Resp;
            }

        }).catch((error) => {
            setloading(false)
        });
    return response;
  }

  const onExportXlsx = (values: ReconciliationTransactionReportModel[]) => {
    setloading(true);
    if (values?.length === 0) {
        setloading(false);
        return;
    }
    const fieldsToExport: (keyof ReconciliationTransactionReportModel)[] = [
        'invoiceNumber', 'insuredName', 'policyNumber',
        'homeState', 'taxType', 'transactionType', 'invDate',
        'policyEffDate', 'policyExpDate', 'grossPremium', 'taxAmt', 'client', 'clientDiv'
    ];
    const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

    const formattedValues = values.map(item => {
        // Helper function to clean and format the value
        const cleanAndFormatValue = (value: string | null | undefined): string => {
            if (value == null || value === '') return ""; // Handle empty, null, or undefined values
        
            // Trim any spaces and remove the dollar sign and commas
            let cleanedValue = value.replace(/[,\$]/g, "").trim();
        
            // If the value is in parentheses, treat it as negative
            if (cleanedValue.startsWith("(") && cleanedValue.endsWith(")")) {
                cleanedValue = "-" + cleanedValue.slice(1, -1);  // Remove parentheses and add negative sign
            }
        
            // Convert to a number and format if valid
            const numericValue = parseFloat(cleanedValue);
            return isNaN(numericValue) ? value : `${formatPrice(numericValue.toString())}`;
        };
    
        // Apply formatting for taxAmt and grossPremium
        item.taxAmt = cleanAndFormatValue(item.taxAmt);
        item.grossPremium = cleanAndFormatValue(item.grossPremium);
    
        // Format dates if they are not null or empty
        const invDate = item.invDate && item.invDate !== '1900-01-01T00:00:00' ? new Date(item.invDate) : "";
        const policyEffDate = item.policyEffDate && item.policyEffDate !== '1900-01-01T00:00:00' ? new Date(item.policyEffDate) : "";
        const policyExpDate = item.policyExpDate && item.policyExpDate !== '1900-01-01T00:00:00' ? new Date(item.policyExpDate) : "";
        const dateFiled = item.dateFiled && item.dateFiled !== '1900-01-01T00:00:00' ? new Date(item.dateFiled) : "";
    
        const update: (string | number | Date | undefined)[] = fieldsToExport.map((key: keyof ReconciliationTransactionReportModel) => {
            if (key === 'invDate') return invDate;
            if (key === 'policyEffDate') return policyEffDate;
            if (key === 'policyExpDate') return policyExpDate;
            if (key === 'dateFiled') return dateFiled;
            return item[key];
        });
    
        return update;
    });
    
    
    const headers = fieldsToExport.map(field => capitalizeFirstLetter(field));

    const updates = [
        headers,
        ...formattedValues
    ];

    writeXlsxFile(updates, "ReconciliationQueue");
    setloading(false);
  };

  const handleExportXlsxNew = async (val: ReconciliationTransactionReportModel[]) => {
    try {
        setloading(true);

        // console.log('selected Rows', selectedRowsRecon);
        // const response = await fetchExportData('getRemovedReconQueueData', [''], ReportModule.totalCount, 1, selectedRowsRecon);
        // console.log('respose',response);
        
        // let values = response
        let arr: ReconciliationTransactionReportModel[] = [];
        let response;
        if (selectedRowsRecon && selectedRowsRecon.length > 0) {
            arr.push(...selectedRowsRecon); // Spread the items only if it's not null
        } else {
            // If selectedRowsRecon is null, make the API request without it and assign the response to `arr`
            response = await fetchExportData('getRemovedReconQueueData', [''], ReportModule.totalCount, 1, selectedRowsRecon);
            console.log('response', response);
            if (response) {
                arr = response; // Assuming response is an array of ReconciliationTransactionReportModel
            }
        }

        let values = arr
        if (val && val?.length > 0) {
            values = val
        }
        if (values?.length <= 0) {
            alert('Please upload a xlsx file')
            return
        }
        onExportXlsx(values);
        setSelectedRows([]);
        fetchDataSorting(_pageSize, _currentPage);
        setloading(false);
    } catch (error) {
        setloading(false);
        console.error("Error occurred:", error);
    }
  }

  const handleClosePaidDialog = () => {
    setOpenPaidDialog(false);
  };

  const updateStatusChange = ({isPaid, paymentPeriod}: StatusUpdateProp) => {
    fetch(
        config + `/ReconQueue/updateReconPaidStatus`,
        {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }),
            body: JSON.stringify({
                selectedRows: selectedRowsRecon,
                isPaid,
                paymentPeriod,
            })
        }
    ).then((response) => {
        if (response.ok) {
            return response.json();
        }
        throw new Error('Something went wrong');
    }).then((res) => {
        if (res.resp === 1) {
            Swal.fire({
                title: res.message,
                text: "",
                icon: "warning",
                confirmButtonText: "OK",
            }).then((result) => {
              window.location.reload();
          });
            console.log("response", res);
        } else if (res.resp === 0) {

            Swal.fire({
                title: "Data Successfully saved",
                text: "",
                icon: "success",
                confirmButtonText: "OK",
            }).then((result) => {
              window.location.reload();
            });
            setSelectedRows([]);
            handleClosePaidDialog();
            fetchDataSorting(_pageSize, _currentPage);

        } else {
            Swal.fire({
                title: "Unexpected response",
                text: "The response code was not recognized.",
                icon: "warning",
                confirmButtonText: "OK",
            }).then((result) => {
              window.location.reload();
            });

            console.log("response", res);
        }
    }).catch((error) => {
        Swal.fire({
            title: "Error",
            text: error.message,
            icon: "error",
            confirmButtonText: "OK",
        });
        console.error('Error:', error);
    });
  }

  const ShowPaymentPeriod = ({ open, handleClose }: newProp) => {
    const initValuePaid: StatusUpdateProp = {
        isPaid: true,
        paymentPeriod: '',
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth={'lg'}>
            <DialogTitle className='card-title'>Payment Period</DialogTitle>
            <React.Fragment>
                <Formik
                    initialValues={initValuePaid}
                    onSubmit={(data, setError) => {
                        updateStatusChange(data)
                    }}
                >
                    {({ values, isSubmitting, setErrors }) => (
                        <Form className='main-form'>

                            <DialogContent>
                                <Grid item xs={12}>
                                    <FormControl sx={{ width: '100%', minWidth: '500px' }}>
                                        <FMTextField
                                            name="paymentPeriod"
                                            label={null}
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            sx={{ marginTop: 2 }}
                                            multiline
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <button className='btn-2 btn d-flex btn-primary search-btn' style={{ minWidth: '125px' }} type='button' onClick={handleClose}>Cancel</button>
                                <button className='btn btn-primary active-btn-blue' type='submit' disabled={isSubmitting}>Submit</button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </React.Fragment>
        </Dialog>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
        {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
      </div>
      {/* Top bar: Title | Filters toggle (when value) - aligned horizontally like Diligent Search */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 2.5,
          borderBottom: '1px solid #e2e8f0',
          backgroundColor: '#fafbfc',
          minHeight: 56,
          // mb: 1,
          marginLeft: { xs: '-24px', md: '0px' },
          marginRight: { xs: '-24px', md: '0px' },
        }}
      >
        <h4 className="d-flex card-title" style={{ fontWeight: 600, fontSize: '0.9375rem', color: '#334155' }}>
          Removed Transaction Queue
        </h4>
        {value && <Box sx={{ flex: 1, minWidth: 120 }} />}
      </Box>
      {/* Filter panel - visible when value */}
      {value && (
        <Box
            sx={{
              width: '100%',
              py: 2,
              px: 2,
              // backgroundColor: '#ffffff',
              // borderBottom: '1px solid #e2e8f0',
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
              className="filter-grid"
              display="flex"
            >
              {user?.userRoles.split(",").includes("Super Admin")
                || user?.userRoles.split(",").includes("MISC State Reporter")
                || user?.userRoles.split(",").includes("MISC Filer")
                ? (
                  <Grid item xl={2} lg={4} sm={6} xs={12}>
                    <FMSelectCustomCustomer name="customer" />
                  </Grid>
                ) : null}
              <Grid item xl={2} lg={4} sm={6} xs={12}>
                <FMSelectStateCustom name="state" />
              </Grid>
              {value && (
                <Grid item xl={2} lg={4} sm={6} xs={12}>
                  <TextField
                    name="Insured Name"
                    size="small"
                    value={insuredName}
                    label="Insured Name"
                    onChange={(e) => setinsuredName(e.target.value)}
                    type="text"
                    fullWidth
                    variant="outlined"
                    id="insuredName"
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c4c4c4" },
                      "& .MuiInputBase-root": { marginTop: '1px !important' },
                      "& .MuiInputBase-input": { padding: '4.5px 14px !important' },
                    }}
                  />
                </Grid>
              )}
              {!value && (
                <Grid item xl={2} lg={4} sm={6} xs={12}>
                  <FormControl fullWidth size="small">
                    <FMSelectTaxAndFeesCustom name="taxName" />
                  </FormControl>
                </Grid>
              )}
              <Grid item xl={2} lg={4} sm={6} xs={12}>
                <TextField
                  value={PolNumber}
                  name="PolicyNumber"
                  size="small"
                  label="Policy Number"
                  onChange={(e) => setpolNumber(e.target.value)}
                  type="text"
                  fullWidth
                  variant="outlined"
                  id="PolicyNumber"
                  sx={{
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c4c4c4" },
                    "& .MuiInputBase-root": { marginTop: '1px !important' },
                    "& .MuiInputBase-input": { padding: '4.5px 14px !important' },
                  }}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  size="medium"
                  onClick={RunSearch}
                  startIcon={<Search />}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    backgroundColor: '#2099d2',
                    '&:hover': { backgroundColor: '#176990' },
                    px: 2,
                  }}
                >
                  Search
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  size="medium"
                  onClick={ClearSearch}
                  startIcon={<Close />}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#e2e8f0",
                    color: "#475569",
                    "&:hover": { borderColor: "#2099d2", color: "#2099d2" },
                  }}
                >
                  Clear
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  size="medium"
                  onClick={() => window.location.reload()}
                  startIcon={<Autorenew />}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#e2e8f0",
                    color: "#475569",
                    "&:hover": { borderColor: "#2099d2", color: "#2099d2" },
                  }}
                >
                  Refresh
                </Button>
              </Grid>
            </Grid>
        </Box>
      )}
      {
        !value && (
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="card-title"></div>
            <div className="d-flex align-items-center mt-2" >
                {(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC State Reporter")) && (selectedRowsRecon !== null && selectedRowsRecon?.length > 0) ?
                    <Button
                      variant="contained"
                      size="medium"
                      onClick={() => setOpenPaidDialog(true)}
                      title="Paid"
                      sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          backgroundColor: '#dc2626',
                      }}
                    >
                        Paid
                    </Button>
                    : ""
                }
                {selectedRowsRecon?.length !== 0 && selectedRowsRecon?.length !== undefined ?
                    <div className="dropdowm-class ms-2" style={{ zIndex: "9" }} >
                        <MenuDropdown
                            menuTitle={'Status'}
                            items={statusList}
                            onItemClick={handleStatus} />
                    </div>
                    : ''}
                <button
                    className=" ms-2  active-btn-blue-export-12  "
                    onClick={() => { handleExportXlsxNew([]) }}
                    title="Export" >
                    Export
                </button>
            </div>
          </div>
        )
      }
      {/* <Box sx={{ height: "calc(100vh - 250px)", display: "flex", flexDirection: "column", width: "100%", backgroundColor: '#ffffff' }}> */}
        { value &&
          <RemovedFilingQueue
            NewCompletedFilingsCL={newComponentDatawithCount}
            getCustomerPolicyListbyTaxType={getCustomerPolicyListbyTaxType}
            setSelectedRows={setSelectedRows}
            selectedRows={selectedRows}
            getCustomerPolicyDetails={getCustomerPolicyDetails}
            setCurrentPage={setCurrentPage}
            _currentPage={_currentPage}
            setPageSize={setPageSize}
            _pageSize={_pageSize}
            filterModel={filterModel}
            setFilterModel={setFilterModel}
            sortModel={sortModel}
            setSortModel={setSortModel}
            fetchDataSorting={fetchDataSorting}
          />
        }
      {/* </Box> */}

        {openNotesDialog && <FilerNotes
          open={!!openNotesDialog}
          handleClose={handleCloseNotesDialog}
          handleSubmit={handleSubmitNotes}
          selectedRows={filteredSelectedRows}
          currentStatus={openNotesDialog}
          currentPolicySubStatus={currentPolicySubStatus}
        />}
        <ShowPaymentPeriod handleClose={handleClosePaidDialog} open={openPaidDialog} />
    </LocalizationProvider>
  );
}
